import { render, staticRenderFns } from "./PropertyCalendarContent.vue?vue&type=template&id=52537f7d&scoped=true&"
import script from "./PropertyCalendarContent.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52537f7d",
  null
  
)

export default component.exports